import { Redirect, Stack } from 'expo-router';
import { useAuth } from '~/auth/contexts/auth/Auth';
import { SidebarLayout } from '~/layout/components/sidebar-layout/SidebarLayout';

export default function Screen() {
  const { auth, isLoadingAuth } = useAuth();
  // While auth is still resolving, hold on the splash rather than bouncing to `/`.
  if (isLoadingAuth) {
    return null;
  }
  if (!auth) {
    return <Redirect href="/" />;
  }
  return (
    <SidebarLayout>
      <Stack screenOptions={{ headerShown: false }}>
        <Stack.Screen name="(tabs)" />
        <Stack.Screen name="(sidebar)" />
        <Stack.Screen name="subscription" />
      </Stack>
    </SidebarLayout>
  );
}
